import { render, staticRenderFns } from "./Irtc.vue?vue&type=template&id=70c24c3b&"
import script from "./Irtc.vue?vue&type=script&lang=js&"
export * from "./Irtc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports